/**
 * Create config common to donut chart types
 */
export var createDonutConfig = function (options) {
    return {
        style: {
            percent: {
                font: options.font,
                fontWeight: 'normal',
                fill: options.textColor
            }
        }
    };
};
